import React,{useEffect} from 'react'
import { connect } from "react-redux";
import {Timer} from "../scripts/game/timer" ;
import {CollectTime} from "../scripts/game/dataCollector" ;
import store from "../store";
import {  genie } from "../shared/assets";
import {goTo} from "../actions/worldAction";
import { logoutUser } from '../actions/authActions';
import overAllSpendTime from "../api/updateTimeSpent";
class MainTimer extends React.Component {
  constructor(props) {
    super(props)
    
    let timeRemaining = 1200 - Math.round(parseInt(store.getState().auth.user.info.playTime));
    localStorage.setItem("timeRemaining", timeRemaining);
    this.state = {
        time : "00:00",
        timeOut : false ,
        deco : false ,
    }

    this.past = Date.now() ;


    this.timer = new Timer({
        onChange : (time) => {this.setState({time})},
        onComplete : () => {
            this.props.dispatch(goTo(0));
            this.setState({timeOut : true});
        },
        delay : timeRemaining ? timeRemaining * 1000 : 1200 * 1000 // 20 minutes
    });
    this.updateGameElapsed = false ;
    this.startGameAt = null ;
    this.tutoDateInAGame = null ;
    this.tutoElapsed =  0 ;
    this.updateTutoElapsed = false ;
    this.howManyTimeTutoOpened = 0 ;
    this.game = null ;
    this.monde = null ;
    this.overallTime = null ;
    // this.timer.updateTime();
  }

componentDidMount() {
    this.timer.init() ;
}

goToMonde0WhenNoTuto = () => {
    if(!this.props.tuto) {
        this.props.dispatch(goTo(0));
    }else {
        setTimeout(() => {
            this.goToMonde0WhenNoTuto();
        }, 500);
    }
    
}
componentWillUnmount() {

}
collectData = () => {
    if(this.updateGameElapsed === true) {
        this.updateGameElapsed = false ;
        let ellapseTime = (Math.floor(Date.now() - this.startGameAt) / 1000  ) 


        CollectTime.addTimeEllapsed(this.game,ellapseTime,this.tutoElapsed,this.howManyTimeTutoOpened) ;
        overAllSpendTime( Math.floor((Date.now() - this.past) / 1000 ));
        this.past = Date.now();
        let timeRemaining = parseInt(localStorage.getItem("timeRemaining"));
        
        if(timeRemaining) {
            localStorage.setItem("timeRemaining", timeRemaining - Math.round( ellapseTime - this.tutoElapsed) ) ;
        }else {
            localStorage.setItem("timeRemaining", 1200 -  Math.round(ellapseTime - this.tutoElapsed ));
        }
        this.tutoElapsed = 0 ;
        this.howManyTimeTutoOpened = 0 ;

    }
}
componentDidUpdate(prevProps, prevState) {

    if(this.state.deco === false && this.state.timeOut === true) {
        const [monde,game] = this.props.iamIn.split(":") ;
        if(monde === "monde0") {
            this.setState({deco : true}) ;
        }
    }
    if(prevProps.iamIn !==  this.props.iamIn || this.props.tuto !== prevProps.tuto) { 
        const [monde,game] = this.props.iamIn.split(":") ;
        
        

        if(game === "MAIN" || game === "BONUS" || game === "BABOUR" || game === "menu" || game === "BALISE") {
            this.collectData();
            this.timer.pause() ;
            this.game = game ;
        }else {
            if(this.game !== game ) {
                this.collectData();
                this.updateGameElapsed = true ;
                this.startGameAt = Date.now() ;
                this.monde = monde ;
                this.game = game ;
            }
            
            if(!this.props.tuto) {
                if(this.updateTutoElapsed) {
                    this.updateTutoElapsed = false ;
                    this.tutoElapsed = this.tutoElapsed + (Math.floor(Date.now() - this.tutoDateInAGame) / 1000  );
                    this.howManyTimeTutoOpened += 1 ;
                } 
                this.timer.start() ;
                
            }else {
                this.tutoDateInAGame = Date.now() ;
                this.updateTutoElapsed = true ;
                this.timer.pause() ;
            }
            
        }
    }

}
render() {
    return <>
    <div style={{position :"absolute",zIndex : 5,left : "25%",transform : "translateX(-50%)",height : 40 ,width : 110}}>
        <SvgShape time = {this.state.time} className={`${this.state.time > "02:00" ? "timeNotClose" : "timeClose"}`} />
    </div>
    {
        (this.state.deco) && <GenieContainer dispatch = {this.props.dispatch}/>
    }
    </>
    // return <button style={{display : "none"}} id="stopBackgroundMusic"onClick={this.stopCurrentMusic}>stop</button> 
    

}
}

const SvgShape = ({time,className}) => {
    const [min,sec] = time.toString().split(":");
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 307 103">

  <g style={{isolation: "isolate"}}>
    <g>
      <g>
        <polygon points="274.59 93.5 32.85 93.5 9.72 9.5 297.72 9.5 274.59 93.5" fill="#FFFFFF" opacity="0.9"/>
        <g>
          <image width="307" height="103" opacity="0.75" xlinkHref="data:image/png;base64,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" style={{mixBlendMode: "multiply"}}/>
          <path d="M295.09,11.5l-22,80H34.37l-22-80H295.09m2.63-2H9.72l23.13,84H274.59l23.13-84Z" fill="#fff"/>
        </g>
      </g>
      <text className={className} fontSize="57" >{min} : {sec}</text>
    </g>
  </g>
</svg>
    )
}   

const mapStateToProps = (state) => {
  return {
    iamIn : state.world.iamIn,
    tuto : state.world.world.tuto
  };
};
export default connect(mapStateToProps)(MainTimer) ; 



const GenieContainer = ({dispatch}) => {
    useEffect(() => {
        setTimeout(() => {
            dispatch(logoutUser());
        },6000) 
    },[])
    return <div className="Genie-Container" >
    <div
      className="box-Genie-container"
    //   style={Object.assign({},{ display: container ? "" : "none"},result ? result.container : null)}
    >
        { true && <svg viewBox="0 0 1152.89 334.13">

<g id="Layer_2" data-name="Layer 2">
<g className="cls-1">
<g className="cls-1">
  <path
    id="p1"
    className="cls-2"
    d="M1152.77,315.92a14.12,14.12,0,0,1-3.38,11.13,13.17,13.17,0,0,1-10.58,4.83l-450.18,2.24-160.56-2.41-513.93-.16A14.15,14.15,0,0,1,0,317.28L17.92,14A14.11,14.11,0,0,1,22.18,4,14.74,14.74,0,0,1,32.26,0L1061.84,14.66A14.15,14.15,0,0,1,1075.67,27Z"
  />
</g>
</g>
</g>
</svg>}
<div className="dialog-genie-container" >
    Vous avez atteint la limite de 20 minutes de jeu. Veuillez vous reconnecter dans 24h !
</div>
</div>

    <video poster={genie[`genie${0}Holder`]} className="Genie-Container-img" 
    
    autoPlay loop muted playsInline>
      <source src={genie[`genie${0}`]} type="video/webm" />
      {/* <img alt="genie" src={genie_img}></img>   */}
      
    </video>

  </div>
}